import { AuctionCardData } from '../../types/auctionCard.type'
import AuctionAvailableCard from '../AuctionAvailableCard'
import AuctionClosedCard from '../AuctionClosedCard'
import AuctionDisputeCard from '../AuctionDisputeCard'

type Props = {
  data: AuctionCardData
}

const AuctionCard = ({ data }: Props) => {
  if (data.status === 'in_dispute') return <AuctionDisputeCard data={data} />
  if (data.status === 'awaiting') return <AuctionAvailableCard data={data} />
  return <AuctionClosedCard data={data} />
}

export default AuctionCard
